import { AxiosInstance } from 'axios'
import axios from 'frontend/_config/axios'
import store from 'frontend/_stores'

import { IBlocker } from '../use-blocker'
import { CacheLayerSingleton } from './cache-layer'
import { type IValidationService } from './types/i-validation-service'

export class ValidationService implements IValidationService {
  public baseUrl: string
  public apiProvider: AxiosInstance
  public blocker: IBlocker
  public validationUrl: string
  public cacheLayer: CacheLayerSingleton
  constructor(
    {
      apiProvider = axios,
      baseUrl,
      blocker,
      validationUrl = `${baseUrl}/validations`,
    }: {
      apiProvider?: AxiosInstance
      baseUrl?: string
      blocker?: IBlocker
      validationUrl?: string
    },
    cacheEnabled = true,
  ) {
    this.baseUrl = baseUrl
    this.apiProvider = apiProvider
    this.blocker = blocker
    this.validationUrl = validationUrl
    if (cacheEnabled) {
      this.cacheLayer = new CacheLayerSingleton()
    }
  }

  getValidations({ validationUrl = this.validationUrl }) {
    if (this.cacheLayer?.has(validationUrl)) {
      return Promise.resolve(this.cacheLayer.get(validationUrl).value)
    }

    if (!validationUrl) {
      return Promise.resolve({})
    }

    if (this.blocker) {
      this.blocker.validation = true
    }

    return this.apiProvider
      .get(validationUrl)
      .then(({ data }) => {
        this.cacheLayer.set(validationUrl, data)

        return data
      })
      .catch(error => {
        console.error('validation service error', error)
        store.dispatch('toast/error', { message: 'Could not fetch validations' })
      })
      .finally(() => {
        if (this.blocker) {
          delete this.blocker.validation
        }
      })
  }
}
